const mainSearchForm = {
  flights: "Vuelos", // translated
  tours: "Excursiones", // translated
  hotel: "Hotel", // translated
  hotels: "Hoteles", // translated
  services: "Servicios", // translated
  search: "BÚSQUEDA", // translated
  destination: "Destino", // translated
  includedServices: "Servicios incluidos", // translated
  packageDuration: "Duración del paquete", // translated
  checkInOut: "El registro de entrada fuera", // translated
  guests: "Huéspedes", // translated
  adults: "Adultos", // translated
  children: "Niños", // translated
  child: "Niño", // translated
  age: "Edad", // translated
  yearsOld: "Años", // translated
  rooms: "Habitaciones", // translated
  close: "Cerrar", // translated
  searchType: "Tipo de búsqueda", // translated
  accommodation: "Alojamiento", // translated
  transfers: "Transferencias", // translated
  toursExperiences: "Tours/Experiencias", // translated
  nights: "Noches", // translated
  days: "Dias", // translated
  packageType: "Tipo de paquete", // translated
  tourType: "Tipo de viaje", // translated
  packages: "Paquetes", // translated
  cars: "Coches", // translated
  cruises: "Cruceros", // translated
  thingsToDo: "Cosas para hacer", // translated
  departureReturn: "Fechas de salida y regreso", // translated
  infantsInSeat: "Bebés en asiento", // translated
  partying: "ir de fiesta", // translated
  dream_packages: "Paquetes de ensueño", // translated
  infantsOnLap: "Bebés en el regazo", // translated
  origin: "Origen", // translated
  roundTrip: "Ida y vuelta", // translated
  isRoundTrip: "es ida y vuelta", // translated
  passengers: "Pasajeros", // translated
  airport: "Aeropuerto", // translated
};


export default mainSearchForm;
